import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=a7f2745a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f2745a')) {
      api.createRecord('a7f2745a', component.options)
    } else {
      api.reload('a7f2745a', component.options)
    }
    module.hot.accept("./Failed.vue?vue&type=template&id=a7f2745a&", function () {
      api.rerender('a7f2745a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/Failed.vue"
export default component.exports